// extracted by mini-css-extract-plugin
export default {"categoryImage":"CategoryImage_categoryImage__ESYwm","image":"CategoryImage_image__mXkPw","svgContainer":"CategoryImage_svgContainer__Fs0Rk"};